const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");

const Reflux = require("reflux");
const FunnelHealthStore = require("../../stores/funnel-health-store");
const FunnelHealthActions = require("../../actions/funnel-health-actions");

const Chart = require("../Dashboard/Chart/chart");

const textFormatter = require("app/util/formatter/text");

const ChartDataLabels = require("chartjs-plugin-datalabels");

const FunnelHealthWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return FunnelHealthStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(FunnelHealthStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    FunnelHealthActions.fetchData(
      this.props.users,
      this.props.funnel
    );
  },

  chartDatasets: function() {
    return (
      [
        {
          label: "Com tarefa",
          data: this.state.data.funnelHealth.map(item => item.withTasks.count),
          backgroundColor: "#0AC390",
          borderColor: "#0AC390"
        },
        {
          label: "Com tarefa atrasada",
          data: this.state.data.funnelHealth.map(item => item.lateTasks.count),
          backgroundColor: "#FFC006",
          borderColor: "#FFC006"
        },
        {
          label: "Sem tarefa",
          data: this.state.data.funnelHealth.map(item => item.noTasks.count),
          backgroundColor: "#FF3856",
          borderColor: "#FF3856"
        }
      ]
    )
  },

  getDetailsUrl: function(id, datasetIndex) {
    let searchParams = new URLSearchParams();
    let forgottenState = "";

    if (datasetIndex === 1) {
      forgottenState = "delayedTasks";
    }
    else if (datasetIndex === 2) {
      forgottenState = "noFutureTasks";
    }

    searchParams.append("ur", id);
    searchParams.append("forgotten", forgottenState);

    searchParams.append("sn", 1);

    if (this.props.funnel) {
      searchParams.append("funil", this.props.funnel);
    }

    return `${betaURL()}/deals?${searchParams}`;
  },

  tooltipText: function(count, percentage, label) {
    const formattedPercentage = textFormatter.formatValuePercentage(percentage);
    const quantity = count > 1 ? "negócios" : "negócio";

    return `${label} : ${count} ${quantity} (${formattedPercentage})`;
  },

  render: function() {
    const chartHeight = 100 + this.state.data.funnelHealth.length * 20;

    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Quem está <strong>esquecendo de agendar</strong> o próximo passo nas negociações?</p>
        }
        className="grid-item-col-2"
      >
        <div className="h-280 ovy-auto thinScrollbar">
          <Chart
            type="horizontalBar"
            plugins={[ChartDataLabels]}
            datasets={this.chartDatasets()}
            labels={this.state.data.funnelHealth.map(item => (
              item.user.name || "Usuário sem nome"
            ))}
            style={{ height: chartHeight }}
            options={{
              maintainAspectRatio: false,
              responsive: true,
              scales: {
                xAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: "QUANTIDADE DE NEGÓCIOS",
                    fontSize: 11,
                    fontStyle: "bold",
                    padding: { top: 20, bottom: 0 }
                  },
                  position: "top",
                  stacked: true,
                  gridLines: {
                    display: false,
                    drawBorder: false
                  },
                  ticks: {
                    display: false
                  }
                }],
                yAxes: [{
                  stacked: true,
                  gridLines: {
                    display: false,
                    drawBorder: false
                  }
                }]
              },
              tooltips: {
                displayColors: true,
                callbacks: {
                  label: (tooltipItem, data) => {
                    const itemData = this.state.data.funnelHealth[tooltipItem.index];
                    let count;
                    let percentage;

                    if (tooltipItem.datasetIndex === 0) {
                      count = itemData.withTasks.count;
                      percentage = itemData.withTasks.percentage;
                    }
                    else if (tooltipItem.datasetIndex === 1) {
                      count = itemData.lateTasks.count;
                      percentage = itemData.lateTasks.percentage;
                    }
                    else {
                      count = itemData.noTasks.count;
                      percentage = itemData.noTasks.percentage;
                    }

                    return this.tooltipText(count, percentage, data.datasets[tooltipItem.datasetIndex].label);
                  }
                }
              },
              hover: {
                intersect: true,
                mode: "nearest"
              },
              onHover: (event, elements) => {
                if (elements.length > 0) {
                  event.target.style.setProperty("cursor", "pointer");
                } else {
                  event.target.style.removeProperty("cursor");
                }
              },
              onClick: (event, [element]) => {
                if (element) {
                  const datasetIndex = element._datasetIndex;
                  const item = this.state.data.funnelHealth[element._index];

                  window.open(this.getDetailsUrl(item.user.id, datasetIndex), "_blank")
                }
              },
              plugins: {
                datalabels: {
                  formatter: function(value, ctx) {
                    let visibleDatasets = ctx.chart.data.datasets.filter(
                      (_, datasetIndex) => ctx.chart.isDatasetVisible(datasetIndex)
                    );

                    if (visibleDatasets.indexOf(ctx.dataset) === visibleDatasets.length - 1) {
                      return visibleDatasets.reduce((sum, dataset) => sum + dataset.data[ctx.dataIndex], 0);
                    }
                    else {
                      return "";
                    }
                  },
                  anchor: "end",
                  align: "end"
                }
              }
            }}
          />
        </div>
      </CardWithLoader>
    )
  }
})

module.exports = FunnelHealthWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/funnel-health-widget.jsx